import React from "react";
import { Shield, FileText, Building2, Bell, ChevronDown } from "lucide-react";
import BusinesVerificationicon from "../../../assets/img/Business Verification icon.svg";
import ContractorLicenseVerificationicon from "../../../assets/img/Contractors License Verification icon.svg";
import moreBadges from "../../../assets/img/More Badges.svg";
import IDVerified from "../../../assets/img/ID Verified.svg";
import BusinessVerified from "../../../assets/img/Business Verified 2.svg";
import LicenseVerified from "../../../assets/img/License Verified.svg";
import TradeCompliance from "../../../assets/img/Trade Compliance.svg";
import Accountability from "../../../assets/img/Accountability.svg";
import PeaceOfMind from "../../../assets/img/Peace of Mind.svg";
import IdentityCheck from "../../../assets/img/Identity Check.svg";
import BusinessVerified2 from "../../../assets/img/Business Verification 3.svg";
import LicenseVerified2 from "../../../assets/img/License Verification 3.svg";
import OngoingMonitoring from "../../../assets/img/Ongoing Monitoring.svg";
import next_icons from "../../../assets/img/next_icons.svg";
import tick from "../../../assets/images/Tick.png";
import downIocn from "../../../assets/img/down icon 2.svg";
import { Button, Col, Row } from "react-bootstrap";
import Professional from "../../../assets/img/Professional.png";
import Client from "../../../assets/img/Client.png";
import Client2 from "../../../assets/img/Client2.png";
import Professional2 from "../../../assets/img/Professional2.png";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const HowWeVetProfessional = () => {
  const navigate = useNavigate();
  const verificationSteps = [
    {
      icon: IdentityCheck,
      title: "Identity Check",
      subtitle: "(Required)",
      description:
        "Government ID verification with biometric check at onboarding.",
    },
    {
      icon: BusinessVerified2,
      title: "Business Verification",
      subtitle: "(Optional but Encouraged)",
      description:
        "Validate business details match the professional's identity.",
    },
    {
      icon: LicenseVerified2,
      title: "License Verification",
      subtitle: "(Optional but Encouraged)",
      description: "Verify active contractor's license with issuing authority.",
    },
    {
      icon: OngoingMonitoring,
      title: "Ongoing Monitoring",
      subtitle: "",
      description:
        "Continuous monitoring to ensure badges remain accurate and up to date.",
    },
  ];

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="custom_container padding_top">
        <div className="vet-container">
          {/* Header Section */}
          <header className="header">
            <h1>How We Vet Professionals</h1>
            <p className="subtitle">
              Hiring the right pro starts with trust. Every professional on
              SimpleRenovate completes a mandatory Identity Verification at
              onboarding. Pros can then add two optional verifications that show
              up as badge on their profile and bids.
            </p>
          </header>

          {/* Top Two Cards */}
          <div className="top-cards-section">
            <div className="top-card">
              <img
                src={BusinesVerificationicon}
                alt="Contractor’s License Verification icon"
              />
              <div className="top-card-flex">
                <h3>Business Verification</h3>
                <p>Confirms the legal business behind the profile</p>
              </div>
            </div>
            <div className="top-card">
              <img
                src={ContractorLicenseVerificationicon}
                alt="Contractor’s License Verification icon"
              />
              <div className="top-card-flex">
                <h3>Contractor’s License Verification</h3>
                <p>Confirms an active trade license where required</p>
              </div>
            </div>
          </div>

          {/* Banner */}
          <div className="banner">
            <span>More Badges = More confidence before your hire</span>
          </div>

          {/* Hero Image Section */}
          <div className="hero-section">
            <img
              src={moreBadges}
              alt="Professional meeting with client"
              className="hero-image"
            />
          </div>

          {/* What Our Program Does Badge */}
          <div className="badge-section">
            <div className="badge">
              <span>What Our Badges Mean</span>
              <img
                src={BusinesVerificationicon}
                alt="Business Verification icon"
                width={40}
                height={40}
              />
              <img
                src={ContractorLicenseVerificationicon}
                alt="Contractor’s License Verification icon"
                width={40}
                height={40}
              />
            </div>
            <p className="our_badges">
              Our badges help you identify licensed and verified professionals
            </p>
          </div>

          {/* Three Red Cards */}
          <div className="red-cards-section">
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={IDVerified} alt="ID Verified" />
              </div>
              <h5>ID Verified (Mandatory)</h5>
              <p>
                We confirm the person is real using government ID and a
                biometric check during onboarding. No ID, no access to the
                marketplace.
              </p>
            </div>
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={BusinessVerified} alt="Business Verified" />
              </div>
              <h5>Business Verified (Optional)</h5>
              <p>
                We validate the business details (legal name and registration)
                match the profile. Completing Business Verification displays the
                badge and unlocks Pro features such as bidding credits.
              </p>
            </div>
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={LicenseVerified} alt="License Verified" />
              </div>
              <h5>License Verified (Optional)</h5>
              <p>
                For licensed trades, we check the contractor’s license with the
                issuing authority (trade, state, and status). If a license
                becomes inactive or expires, the badge is removed until updated.
              </p>
            </div>
          </div>

          <div className="badge-section">
            <p className="our_badges">
              Note: License requirements vary by location and trade. Always
              follow local permitting rules.
            </p>
          </div>

          <div className="verification-container">
            <h2 className="verification-title">
              How Professionals Get Verified
            </h2>
            <p className="verification-subtitle">
              Our comprehensive verification process ensures trust and
              accountability at every step
            </p>

            <div className="verification-steps">
              {verificationSteps.map((step, index) => {
                const IconComponent = step.icon;
                const isLast = index === verificationSteps.length - 1;

                return (
                  <div key={index} className="verification-step">
                    <div className="step-content">
                      <div
                        className="icon-wrapper"
                        style={{ color: step.iconColor }}
                      >
                        <img src={step.icon} alt={step.title} />
                      </div>

                      <div className="step-details">
                        <div className="step-header">
                          <h3 className="step-title">{step.title}</h3>
                          {step.subtitle && (
                            <span className="step-subtitle">
                              {step.subtitle}
                            </span>
                          )}
                        </div>
                        <p className="step-description">{step.description}</p>
                      </div>
                    </div>

                    {!isLast && (
                      <div className="step-divider">
                        <img src={downIocn} alt="Down Icon" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Three Red Cards */}
          <div className="footer-cta">
            <h2>Why Hire a Verified Professional?</h2>
          </div>

          <div className="red-cards-section">
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={PeaceOfMind} alt="Peace of Mind" />
              </div>
              <h5 style={{ color: "#cc4645" }}>Peace of Mind</h5>
              <p>
                Everyone is identity-verified, so you’re hiring real people—not
                anonymous profiles
              </p>
            </div>
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={Accountability} alt="Accountability" />
              </div>
              <h5 style={{ color: "#cc4645" }}>Accountability</h5>
              <p>
                The badge shows there’s a validated business behind the work.
              </p>
            </div>
            <div className="red-card">
              <div className="red-icon-wrapper">
                <img src={TradeCompliance} alt="Trade Compliance" />
              </div>
              <h5 style={{ color: "#cc4645" }}>Trade Compliance</h5>
              <p>
                The badge indicates an active license for the listed trade and
                state, helping you meet local rules.
              </p>
            </div>
          </div>

          <Row className="px-2 mt-3 mt-md-5 margin_bottom_aboutus_flex">
            <Col lg={6} className="text-center">
              <Row className="g-0">
                {/* First Row */}
                <Col xs={6}>
                  <Image
                    src={Professional}
                    alt="Image 1"
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                    className="Professional2_image"
                  />
                </Col>
                <Col xs={6}>
                  <Image
                    src={Client}
                    alt="Image 2"
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                    className="Client_image"
                  />
                </Col>

                {/* Second Row */}
                <Col xs={6}>
                  <Image
                    src={Client2}
                    alt="Image 3"
                    style={{
                      width: "100%",
                      height: "180px", // smaller
                      objectFit: "fill",
                      borderRadius: "16px",
                    }}
                    className="Client_image"
                  />
                </Col>
                <Col xs={6}>
                  <Image
                    src={Professional2}
                    alt="Image 4"
                    style={{
                      width: "100%",
                      height: "370px",
                      borderRadius: "16px",
                      position: "relative",
                      bottom: "187px",
                    }}
                    className="Professional2_image"
                  />
                </Col>
              </Row>
            </Col>
            <Col lg={6} className="col_md_style">
              <div className="ms-0 ms-md-4">
                <h3
                  className="fw-bold mt-3 mt-md-4 mb-3 text-center text-sm-start"
                  style={{
                    background:
                      "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  How to Find a Verified Professional?
                </h3>
                <div className="card_vet_professional_2">
                  <img
                    src={tick}
                    alt="Icon"
                    style={{ height: "20px", width: "20px" }}
                    className="mt-1"
                  />
                  <span
                    className="mb-3 boost_bid_text_para"
                    style={{ lineHeight: "1.4" }}
                  >
                    When reviewing bids, look for the badges next to a pro’s
                    name: <span style={{ filter: "brightness(0.5)" }}>✔️</span>{" "}
                    Business Verified and 🛡️ License Verified.
                  </span>
                </div>
                <div className="card_vet_professional_2">
                  <img
                    src={tick}
                    alt="Icon"
                    style={{ height: "20px", width: "20px" }}
                    className="mt-1"
                  />
                  <span
                    className="mb-3 boost_bid_text_para"
                    style={{ lineHeight: "1.4" }}
                  >
                    Use filters to show bids from{" "}
                    <span style={{ filter: "brightness(0.5)" }}>✔️</span>{" "}
                    Business-Verified pros and/or 🛡️ License-Verified pros only
                  </span>
                </div>
                <div className="card_vet_professional_2">
                  <img
                    src={tick}
                    alt="Icon"
                    style={{ height: "20px", width: "20px" }}
                    className="mt-1"
                  />
                  <span
                    className="mb-3 boost_bid_text_para"
                    style={{ lineHeight: "1.4" }}
                  >
                    Prefer both? Filter for pros with both badges for maximum
                    confidence.
                  </span>
                </div>

                <div className="mt-3 mt-md-4">
                  <span className="boost_bid_text_para fw-bold">
                    Get started today and hire with confidence!
                  </span>
                </div>
                <div className="client-login-width p-0 align-items-start mt-3 text-center text-sm-start">
                  <Button
                    variant="primary"
                    className="create-account-login"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Client" },
                      });
                    }}
                  >
                    Find Professionals{" "}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <section className="cta-sections">
        <div className="cta-container">
          <h2 className="cta-title">Ready to get started?</h2>
          <p className="cta-subtitle">
            Get started today and hire with confidence!
          </p>
          <div className="cta_btn_center">
            <button
              className="cta-button"
              onClick={() => {
                handleViewDetails();
                navigate("/select-role", { state: { clickBy: "Client" } });
              }}
            >
              Find Professionals
              {/* <img src={next_icons} alt="next_icons" /> */}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default HowWeVetProfessional;
